import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import Vuelidate from 'vuelidate'
import VueGtag from 'vue-gtag'
import VueMask from 'v-mask'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(VueMask)
Vue.use(Vuelidate)
Vue.use(Buefy)
Vue.use(VueGtag, {
  config: { id: 'UA-140417741-1' }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
